module.exports = __webpack_public_path__ + "static/headshot-6ff0bc22c6fc29b66581278a27bffaf4.jpg";